import { useState, useEffect } from 'react';

const VIEW_MODE_KEY = 'crm_view_mode'; // 'auto' | 'desktop' | 'mobile'
export const VIEW_MODE_EVENT = 'crm-view-mode-changed';

export function getViewMode() {
  try {
    const v = localStorage.getItem(VIEW_MODE_KEY);
    return v === 'desktop' || v === 'mobile' ? v : 'auto';
  } catch { return 'auto'; }
}

export function setViewMode(mode) {
  try {
    if (mode === 'auto') localStorage.removeItem(VIEW_MODE_KEY);
    else localStorage.setItem(VIEW_MODE_KEY, mode);
  } catch {}
  window.dispatchEvent(new CustomEvent(VIEW_MODE_EVENT));
}

export function detectMobileDevice() {
  const ua = navigator.userAgent || navigator.vendor || '';
  const isMobileUa = /android|iphone|ipad|ipod|mobile|blackberry|iemobile|opera mini/i.test(ua);
  // Use innerWidth as the primary signal — reliable even in "desktop mode" on Safari
  const isSmallScreen = window.innerWidth <= 900;
  const hasTouch =
    window.matchMedia('(pointer: coarse)').matches ||
    navigator.maxTouchPoints > 0;
  // Treat as mobile if UA says so, OR small screen with touch, OR very small screen regardless
  return isMobileUa || (isSmallScreen && hasTouch) || window.innerWidth <= 640;
}

function resolveIsMobile() {
  const mode = getViewMode();
  if (mode === 'desktop') return false;
  if (mode === 'mobile') return true;
  return detectMobileDevice();
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(resolveIsMobile);

  useEffect(() => {
    const handler = () => setIsMobile(resolveIsMobile());
    window.addEventListener('resize', handler);
    window.addEventListener('orientationchange', handler);
    window.addEventListener(VIEW_MODE_EVENT, handler);
    // Also re-check after fonts/layout settle
    const t = setTimeout(handler, 300);
    return () => {
      window.removeEventListener('resize', handler);
      window.removeEventListener('orientationchange', handler);
      window.removeEventListener(VIEW_MODE_EVENT, handler);
      clearTimeout(t);
    };
  }, []);

  return isMobile;
}
